const PLAIN_DECIMAL_WITH_COMMA = /^-?\d+,\d+$/;

export const normalizeFormula = (formula: string): string => {
  const trimmedFormula = formula.trim();

  if (!PLAIN_DECIMAL_WITH_COMMA.test(trimmedFormula)) {
    return formula;
  }

  return trimmedFormula.replace(",", ".");
};
